<template>
  <div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
        ><h5><i class="dot"></i>기본정보</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">공종명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_5 }}</p>
          <vs-select
            v-model="form.inputA_5"
            autocomplete
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
          >
            <vs-select-item
              :key="item.value"
              v-for="item in selects"
              :value="item.value"
              :text="item.label"
            ></vs-select-item>
          </vs-select>
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">평가일시</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_6 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_6"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">평가자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_7 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_7"
            class="w-full flex-1"
            :readonly="board.readonly"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">평가장소</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputA_1"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">소속</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_0 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_0"
            :readonly="true"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">부서</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">대상기간</div>
          <span v-if="isPrint" class=" ">
            {{ form.inputA_8 }}
          </span>
          <date-selector
            v-else
            v-model="form.inputA_8"
            class="w-full flex-1"
            :readonly="board.readonly"
          ></date-selector>
          <span class="px-3">~</span>
          <span v-if="isPrint" class="">
            {{ form.inputA_9 }}
          </span>
          <date-selector
            v-else
            v-model="form.inputA_9"
            class="w-full flex-1"
            :readonly="board.readonly"
          ></date-selector>
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">예정공정표 첨부</div>
          <p v-if="isPrint" class="w-full flex-1">
            {{ form.inputA_10.fileName }}
          </p>
          <file-uploader
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_10"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4 center-flex">
        <h5><i class="dot"></i>4M 위험성 평가표</h5>
        <div class="ml-auto">
          <vs-button
            v-if="!isPrint"
            class=""
            color="secondary"
            type="border"
            @click="handleAddRow"
          >항목추가
          </vs-button
          >
          <vs-button
            v-if="!isPrint"
            class="ml-4"
            color="secondary"
            @click="handleRemoveRow"
          >선택삭제
          </vs-button
          >
        </div>
      </vs-row>
      <div class="form-group grid">
        <div class="overflow-x-auto">
          <div class="form-group__header"
               style="display: grid; grid-template-columns: 40px 220fr 200fr 185fr 200fr 185fr 255fr 185fr 255fr;">
            <vs-checkbox
              @change="handleCheckAll"
              class="form-group__header-title title-checked"
              v-model="form.input_check"
            ></vs-checkbox>
            <div class="form-group__header-title row-w1">세부작업명</div>
            <div class="form-group__header-title">평가구분</div>
            <div class="form-group__header-title">유해·위험요인</div>
            <div class="form-group__header-title">재해형태</div>
            <div class="form-group__header-title">현재 안전보건조치</div>
            <div class="form-group__header-title row-w0 flex-col">
              <p class="h-full w-full center-flex bb">현재 위험도</p>
              <div class="flex h-full w-full">
                <div class="flex-1 center-flex">가능성</div>
                <div class="flex-1 center-flex bx">중대성</div>
                <div class="flex-1 center-flex">
                  위험도
                  <vx-tooltip title="위험도이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                              style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                              position="top" delay=".1s">
                    <feather-icon icon="AlertCircleIcon"
                                  style="cursor: pointer; width:16px;"
                                  @click="onClickToolTip()"
                    />
                  </vx-tooltip>
                </div>
              </div>
            </div>
            <div class="form-group__header-title row-w0">위험감소대책</div>
            <div class="form-group__header-title row-w0 flex-col">
              <p class="h-full w-full center-flex bb">개선후 위험도</p>
              <div class="flex h-full w-full">
                <div class="flex-1 center-flex">코드번호</div>
                <div class="flex-1 center-flex bx">빈도</div>
                <div class="flex-1 center-flex br">강도</div>
                <div class="flex-1 center-flex">
                  위험도
                  <vx-tooltip title="위험도이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                              style="margin-left:4px; display: flex; align-items: center; justify-content: center;"
                              position="top" delay=".1s">
                    <feather-icon icon="AlertCircleIcon"
                                  style="cursor: pointer; width:16px;"
                                  @click="onClickToolTip()"
                    />
                  </vx-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-group__content"
            style="display: grid; grid-template-columns: 40px 220fr 200fr 185fr 200fr 185fr 255fr 185fr 255fr;"
            v-for="row in form.list"
            :key="row.id"
          >
            <vs-checkbox
              class="form-group__content-row row-checked"
              v-model="row.inputB_check"
              :readonly="board.readonly"
            ></vs-checkbox>
            <div class="form-group__content-row row-w1">
              <p v-if="isPrint">
                {{ row.inputB_1 }}
              </p>
              <ml-textarea
                class="m-0"
                :readonly="board.readonly"
                v-else

                rows="3"
                v-model="row.inputB_1"
              />
            </div>
            <div class="form-group__content-row">
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.inputB_2 }}
              </p>
              <check-type-a-selector
                v-else
                v-model="row.inputB_2"
                :readonly="board.readonly"
                class="w-full"
              />
            </div>
            <div class="form-group__content-row">
              <p v-if="isPrint">
                {{ row.inputB_3 }}
              </p>
              <ml-textarea
                class="m-0"
                :readonly="board.readonly"
                v-else

                rows="3"
                v-model="row.inputB_3"
              />
            </div>
            <div class="form-group__content-row">
              <p v-if="isPrint" class="w-full flex-1">
                {{ row.inputB_4 }}
              </p>
              <disaster-class-selector
                v-else
                class="w-full"
                v-model="row.inputB_4"
              />
            </div>
            <div class="form-group__content-row">
              <p v-if="isPrint">
                {{ row.inputB_5 }}
              </p>
              <ml-textarea
                class="m-0"
                :readonly="board.readonly"
                v-else

                rows="3"
                v-model="row.inputB_5"
              />
            </div>
            <div class="form-group__content-row row-w0 p-0 flex">
              <div class="flex-1 p-2">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_6 }}
                </p>
                <vs-select
                  v-else
                  class="w-full"
                  autocomplete
                  v-model="row.inputB_6"
                  @change="
                    handleChangeinput(
                      row.id,
                      row.inputB_6,
                      row.inputB_7,
                      'inputB_8'
                    )
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in optionsNumber1"
                  />
                </vs-select>
              </div>
              <div class="flex-1 p-2 bx">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_7 }}
                </p>
                <vs-select
                  v-else
                  class="w-full"
                  autocomplete
                  v-model="row.inputB_7"
                  @change="
                    handleChangeinput(
                      row.id,
                      row.inputB_6,
                      row.inputB_7,
                      'inputB_8'
                    )
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in optionsNumber2"
                  />
                </vs-select>
              </div>
              <div class="flex-1 p-2">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_8 }}
                </p>
                <ml-input
                  :readonly="true"
                  class="w-full"
                  v-model="row.inputB_8"
                  v-else
                  :style="{ color: row.inputB_8_color }"
                />
              </div>
            </div>
            <div class="form-group__content-row row-w0">
              <p v-if="isPrint">
                {{ row.inputB_9 }}
              </p>
              <ml-textarea
                class="m-0"
                :readonly="board.readonly"
                v-else

                rows="3"
                v-model="row.inputB_9"
              />
            </div>
            <div class="form-group__content-row row-w0 p-0 flex">
              <div class="flex-1 p-2">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_10 }}
                </p>
                <ml-input
                  :readonly="true"
                  class="w-full"
                  v-model="row.inputB_10"
                  v-else
                />
              </div>
              <div class="flex-1 p-2 bx">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_11 }}
                </p>
                <vs-select
                  v-else
                  class="w-full"
                  autocomplete
                  v-model="row.inputB_11"
                  @change="
                    handleChangeinput(
                      row.id,
                      row.inputB_11,
                      row.inputB_12,
                      'inputB_13'
                    )
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in optionsNumber1"
                  />
                </vs-select>
              </div>
              <div class="flex-1 p-2 br">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_12 }}
                </p>
                <vs-select
                  v-else
                  class="w-full"
                  autocomplete
                  v-model="row.inputB_12"
                  @change="
                    handleChangeinput(
                      row.id,
                      row.inputB_11,
                      row.inputB_12,
                      'inputB_13'
                    )
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item, index) in optionsNumber2"
                  />
                </vs-select>
              </div>
              <div class="flex-1 p-2">
                <p v-if="isPrint" class="w-full flex-1">
                  {{ row.inputB_13 }}
                </p>
                <ml-input
                  :readonly="true"
                  class="w-full"
                  v-model="row.inputB_13"
                  v-else
                  :style="{ color: row.inputB_13_color }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-box">
        <div class="center-flex h-12 bg-1">
          <feather-icon
            icon="AlertTriangleIcon"
            class="ml-1"
            style="width:18px; height:18px;"
          />
          위험성 결정
        </div>
        <div class="p-4 text-sm font-medium ">
          <p>
            ※ 가능성 : 5(매우 높음), 4(높음), 3(보통), 2(낮음), 1(매우 낮음)
          </p>
          <p>
            ※ 중대성 : 4(사망, 장애발생), 3(휴업필요 부상/질병), 2(휴업 불필요
            부상/질병), 1(비치료)
          </p>
          <p>
            ※ 위험성 : 가능성 X 중대성
          </p>
          <p>
            ※ 위험성 감소대책 : 위험성이 8 이상인 유해·위험요인에 대해서는 현재
            조치되어 있지 않은 위험성 감소대책을 수립·기재
          </p>
          <p>
            ※ 코드NO : (등급)-(연번) ex)A-1, B-2
          </p>
        </div>
      </div>
    </div>
    <file-upload-module
      :readonly="board.readonly"
      v-if="!isPrint"
      class=" w-full mt-5"
      v-model="form.fileList"
    />

    <popup-risk-info v-model="showInfoPopup"></popup-risk-info>
  </div>
</template>

<script>
import DateSelector from '@/components/selector/DateSelector.vue'
import TimeSelector from '@/components/selector/TimeSelector.vue'
import FileUploadModule from '@/views/modules/FileUploadModule.vue'
import FileUploader from '@/components/FileUploader.vue'
import SearchNavStartEnd from '@/components/nav/SearchNavStartEnd.vue'
import CheckTypeASelector from '../../../../components/selector/CheckTypeASelector.vue'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector.vue'
import PopupRiskInfo from '@/views/project/popup/PopupRiskInfo'

export default {
  components: {
    PopupRiskInfo,
    DateSelector,
    TimeSelector,
    FileUploadModule,
    FileUploader,
    SearchNavStartEnd,
    CheckTypeASelector,
    DisasterClassSelector
  },
  name: 'Write',
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.writer.com_name
        this.form.inputA_3 = this.value && this.value.inputA_3 ? this.value.inputA_3 : this.board.writer.name
        this.form.inputA_0 = this.value && this.value.inputA_0 ? this.value.inputA_0 : this.board.writer.department
      }
    },
    value (value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }
      if (typeof this.form.inputA_10 !== 'object') {
        this.form.inputA_10 = {}
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_1
        value.summary = {
          공종명: [],
          재해형태: [],
        }
        value.summary['공종명'].push({[this.form.inputA_5]: 1})

        const _temp = {}
        for (const row of this.form.list) {
          if (_temp[row.inputB_4]) {
            _temp[row.inputB_4] = _temp[row.inputB_4] + 1
          } else {
            _temp[row.inputB_4] = 1
          }
        }
        const _keys = Object.keys(_temp)
        for (const key of _keys) {
          value.summary['재해형태'].push({[key]: _temp[key]})
        }

        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      showInfoPopup: false,
      objLevel: {},
      optionsNumber1: [
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'},
        {value: 5, label: '5'}
      ],
      optionsNumber2: [
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'}
      ],
      selects: [
        {value: '선택 항목', label: '선택 항목'},
        {value: '잠수작업', label: '잠수작업'},
        {
          value: '인공어초 제작 및 시설 작업',
          label: '인공어초 제작 및 시설 작업'
        },
        {value: '자연석 시설 작업', label: '자연석 시설 작업'},
        {value: '갯벌작업', label: '갯벌작업'},
        {value: '선박작업(해상작업)', label: '선박작업(해상작업)'},
        {value: '분석 작업', label: '분석 작업'}
      ],
      form: {
        fileList: [],
        inputA_0: '',
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '선택 항목',
        inputA_6: '',
        inputA_7: '',
        inputA_8: '',
        inputA_9: '',
        inputA_10: {},
        input_check: false,
        list: [
          {
            id: 0,
            inputB_check: false,
            inputB_1: '',
            inputB_2: '',
            inputB_3: '',
            inputB_4: '',
            inputB_5: '',
            inputB_6: 1,
            inputB_7: 1,
            inputB_8: 'F',
            inputB_8_color: '#28C76F',
            inputB_9: '',
            inputB_10: 'F-1',
            inputB_11: 1,
            inputB_12: 1,
            inputB_13: 'F',
            inputB_13_color: '#28C76F'
          }
        ]
      }
    }
  },
  methods: {
    onClickToolTip () {
      this.showInfoPopup = true
    },
    checkColor (value) {
      if (value >= 1 && value <= 3) {
        return '#28C76F'
      } else if (value >= 4 && value <= 6) {
        return '#FF8510'
      } else {
        return '#E42728'
      }
    },
    handleResult (result) {
      if (result >= 1 && result <= 3) return 'F'
      else if (result >= 4 && result <= 6) return 'E'
      else if (result === 8) return 'D'
      else if (result >= 9 && result <= 12) return 'C'
      else if (result === 15) return 'B'
      else if (result >= 16 && result <= 20) return 'A'
    },
    handleChangeinput (id, n1, n2, string) {
      let f = 1
      let e = 1
      let d = 1
      let c = 1
      let b = 1
      let a = 1
      const value = n1 * n2
      const color = `${string}_color`
      const result = this.handleResult(value)
      this.form.list.forEach((i, index) => {
        for (const key in i) {
          if (key === string && i.id === id) {
            this.form.list[index][key] = result
            this.form.list[index][color] = this.checkColor(value)
          }
          if (key.includes('_8')) {
            if (this.form.list[index][key] === 'F') {
              this.form.list[index].inputB_10 = `F-${f}`
              f++
            } else if (this.form.list[index][key] === 'E') {
              this.form.list[index].inputB_10 = `E-${e}`
              e++
            } else if (this.form.list[index][key] === 'D') {
              this.form.list[index].inputB_10 = `D-${d}`
              d++
            } else if (this.form.list[index][key] === 'C') {
              this.form.list[index].inputB_10 = `C-${c}`
              c++
            } else if (this.form.list[index][key] === 'B') {
              this.form.list[index].inputB_10 = `B-${b}`
              b++
            } else if (this.form.list[index][key] === 'A') {
              this.form.list[index].inputB_10 = `A-${a}`
              a++
            }
          }
        }
      })
    },

    handleCheckAll (e) {
      const checked = e.target.checked
      this.form.list.forEach(e => {
        e.inputB_check = checked
      })
    },

    handleAddRow () {
      this.form.list.push({
        id: this.form.list.length,
        inputB_check: false,
        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',
        inputB_6: 1,
        inputB_7: 1,
        inputB_8: 'F',
        inputB_8_color: '#28C76F',
        inputB_9: '',
        inputB_10: 'F-1',
        inputB_11: 1,
        inputB_12: 1,
        inputB_13: 'F',
        inputB_13_color: '#28C76F'
      })
    },
    handleRemoveRow () {
      if (this.form.list.length === 1) {
        //
      } else {
        this.form.list = this.form.list.filter(x => x.inputB_check === false)
        this.form.input_check = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
